module.exports = __webpack_public_path__ + "static/media/eiffelDefault.c99451f5.png";